export function fetchMobilesViewsHistory(shop, offer, universe, browserId, clientId, intention) {
    let url = "/api/mobile/mobiles/history"
    return new Promise((resolve, reject) => {
        $.ajax({
            method: "GET",
            data: {
                "shop": shop,
                "offer": offer,
                "browser-id": browserId,
                "client-id": clientId,
                "universe": universe,
                "intention": intention,
            },
            url: url,
            contentType: "application/json",
            dataType: "json"
        }).done(result => {
            resolve(result)
        }).fail(error => {
            reject(error)
        })
    })
}
